import { getFirebaseTokenFromCookies } from "@/modules/users/service/cookies";

/**
 * La matrícula del médico.
 *
 * No está en el usuario de SQL: vive en el perfil profesional de Firestore,
 * que es de donde la lee el backend para estamparla en el protocolo. Estas
 * dos llamadas van contra el propio portal (`/api/doctors/...`), que es quien
 * tiene las credenciales de administración.
 */
export type Matricula = {
	/** `false` si el médico ni siquiera tiene perfil profesional. */
	tieneProvider: boolean;
	matricula: number | null;
	licenseType: string | null;
	speciality: string | null;
};

async function mensajeDeError(
	respuesta: Response,
	porDefecto: string,
): Promise<string> {
	const cuerpo = await respuesta.json().catch(() => null);
	return cuerpo?.message || porDefecto;
}

export async function traerMatricula(uid: string): Promise<Matricula> {
	const firebaseToken = await getFirebaseTokenFromCookies();
	const respuesta = await fetch(
		`/api/doctors/${encodeURIComponent(uid)}/license`,
		{ headers: { Authorization: `Bearer ${firebaseToken}` } },
	);

	if (!respuesta.ok) {
		throw new Error(
			await mensajeDeError(respuesta, "No pudimos leer la matrícula"),
		);
	}

	return respuesta.json();
}

export async function guardarMatricula(
	uid: string,
	datos: { matricula: number; licenseType: string; speciality?: string },
): Promise<void> {
	const firebaseToken = await getFirebaseTokenFromCookies();
	const respuesta = await fetch(
		`/api/doctors/${encodeURIComponent(uid)}/license`,
		{
			method: "PATCH",
			headers: {
				Authorization: `Bearer ${firebaseToken}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(datos),
		},
	);

	if (!respuesta.ok) {
		throw new Error(
			await mensajeDeError(respuesta, "No pudimos guardar la matrícula"),
		);
	}
}
